<template>
	<!-- :key="$route.fullPath" 解决了路由前缀相同时跳转不刷新 -->
  <div id="app" class="mobile-optimized-app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // Add mobile-specific optimizations
    this.addMobileOptimizations();
  },
  methods: {
    addMobileOptimizations() {
      // Prevent zoom on double tap for iOS
      let lastTouchEnd = 0;
      document.addEventListener('touchend', function (event) {
        const now = (new Date()).getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      }, false);

      // Add smooth scrolling for mobile
      document.documentElement.style.scrollBehavior = 'smooth';
      
      // Improve touch feedback
      const touchElements = document.querySelectorAll('button, a, .clickable');
      touchElements.forEach(element => {
        element.addEventListener('touchstart', function() {
          this.style.transform = 'scale(0.98)';
        });
        element.addEventListener('touchend', function() {
          this.style.transform = '';
        });
      });
    }
  }
}
</script>

<style>
/* Mobile-optimized app styles */
.mobile-optimized-app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

/* Prevent horizontal scroll on mobile */
html, body {
  overflow-x: hidden;
  width: 100%;
}

/* Improve touch targets */
button, a, .clickable {
  min-height: 44px;
  min-width: 44px;
}

/* Better text rendering on mobile */
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Smooth transitions for mobile */
* {
  transition: all 0.2s ease;
}

/* Mobile-specific improvements */
@media (max-width: 768px) {
  /* Improve scrolling performance */
  .mobile-optimized-app {
    -webkit-overflow-scrolling: touch;
  }
  
  /* Better focus states for accessibility */
  button:focus,
  a:focus,
  input:focus,
  textarea:focus {
    outline: 2px solid #0e90d2;
    outline-offset: 2px;
  }
  
  /* Prevent text selection on interactive elements */
  button, a, .clickable {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
}

/* High contrast mode support */
@media (prefers-contrast: high) {
  .mobile-optimized-app {
    --primary-color: #000;
    --secondary-color: #fff;
  }
}

/* Reduced motion support */
@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}
</style>

